"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Cread;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Cread(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "cread"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M67.11,33.73H57.83a3,3,0,0,1-.25-.25V24l4.72,4.93Zm14-24H38.19a1.5,1.5,0,0,0-1.5,1.5v3.13h15.7a6.76,6.76,0,0,1,4.77,2h.42v.44l8.3,8.67,8.3,8.3h.41v.41l.36.36a6.65,6.65,0,0,1,2,4.73V75.65h4.22a1.5,1.5,0,0,0,1.5-1.5v-63A1.5,1.5,0,0,0,81.13,9.69ZM54.18,62a3.65,3.65,0,0,0,2.39.78,4.47,4.47,0,0,0,2.6-.71,4.72,4.72,0,0,0,1.63-1.92v-6.9a5,5,0,0,0-1.55-2,4.18,4.18,0,0,0-2.65-.79,3.68,3.68,0,0,0-2.41.79,4.61,4.61,0,0,0-1.45,2.14,9.65,9.65,0,0,0-.47,3.12v.28a9.63,9.63,0,0,0,.47,3.11A4.62,4.62,0,0,0,54.18,62ZM39.72,46.26,35.77,57h7.89Zm32.19-7v46.3a1.7,1.7,0,0,1-1.7,1.69H24.85a1.5,1.5,0,0,1-1.5-1.5V21A1.69,1.69,0,0,1,25,19.32H52.39l.19,0V33.83a5.47,5.47,0,0,0,4.91,4.9H71.82A1.7,1.7,0,0,1,71.91,39.23ZM50.65,56.75a10.19,10.19,0,0,0,.69,3.87,6,6,0,0,0,2,2.63,4.8,4.8,0,0,0,3,.94,5.91,5.91,0,0,0,2.68-.58A5.17,5.17,0,0,0,60.83,62l.08,2h1.51V43.15H60.8v8.18a5.1,5.1,0,0,0-1.87-1.71,5.57,5.57,0,0,0-2.65-.6,5,5,0,0,0-3,.91,5.7,5.7,0,0,0-2,2.6,10.32,10.32,0,0,0-.68,3.94ZM31.48,63.92h1.73l2-5.52h8.95l2,5.52H48L40.5,44.23H38.92ZM30.1,71a1.5,1.5,0,0,0,1.5,1.5H63.65a1.5,1.5,0,1,0,0-3h-32A1.5,1.5,0,0,0,30.1,71Zm35.13,7.18a1.5,1.5,0,0,0-1.5-1.5h-32a1.5,1.5,0,0,0,0,3H63.73A1.5,1.5,0,0,0,65.23,78.13Z"
  }))));
}